export default __webpack_public_path__ + "static/media/IF_MyDevelopment_Small.5c164637.jpg";